import "aos/dist/aos.css";
import React from 'react';
import { Link } from "react-router-dom";

const NotFound = () => {

  return (
    <section>
      <div className="w-100 d-flex justify-content-center" style={{ "paddingTop": "150px" }}>
        <h3>Хуудас олдсонгүй</h3>
      </div>
      <div className="w-100 d-flex justify-content-center" style={{ marginTop: 20, marginBottom: 20, textDecoration: "underline"}}>
        <Link className="button" to="/">Нүүр хуудас руу очих</Link>
      </div>
    </section>
  );
};
export default NotFound;
